import { useSearchParams } from 'react-router';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';

/**
 * This hook encapsulates routing logic that depends on both URL query params and runtime context
 * (device type). React Router v6 cannot conditionally render based on query params or context
 * directly in route configuration - it only matches on path segments. Therefore, we use a
 * component wrapper with this hook to make the routing decision at runtime.
 *
 * Desktop: Shows HealthTopicsBrowsePage (both topics + programs side-by-side)
 * Mobile/Tablet with topicId: Shows CareProgramsListPage only (full screen)
 * Any device without topicId: Shows HealthTopicsBrowsePage (browse all topics)
 *
 * @returns {boolean} True when on mobile/tablet devices and a topicId is present in the URL
 */
export const useResourceView = () => {
  const [searchParams] = useSearchParams();
  const { isMobile, isTablet } = useDeviceType();
  const topicId = searchParams.get('topicId');
  const isMobileTabletView = (isMobile || isTablet) && Boolean(topicId);
  return isMobileTabletView;
};
